import React from 'react';
import { Suggestion } from '@components/common/Suggestion';
import { StepProgressBar } from '@fourthwall/components/dist/common/StepProgressBar';
import { useRecommendationsDismiss } from '@modules/Dashboard/Home/modules/recommendations/useRecommendationsDismiss';
import * as S from './styled';
export const CreatorChallengeSuccessContainer = ({ numberOfOrders, reward, onDismiss, }) => {
    const { recommendationsDismiss } = useRecommendationsDismiss();
    const handleDismiss = () => {
        recommendationsDismiss.creatorChallenge.dismiss();
        onDismiss();
    };
    return (React.createElement(S.CurrentChallengeProgressContainer, null,
        React.createElement(Suggestion, { title: `You sold ${numberOfOrders} products and completed your challenge!`, onDismiss: handleDismiss, content: React.createElement("div", null,
                React.createElement("p", null,
                    reward,
                    " has been refunded to the payment method used to place the sample order."),
                React.createElement(S.ProgressBarContainer, null,
                    React.createElement(StepProgressBar, { step: numberOfOrders, totalSteps: numberOfOrders })),
                React.createElement(S.ProgressSubtitles, null,
                    React.createElement("span", null,
                        numberOfOrders,
                        " out of ",
                        numberOfOrders,
                        " products sold"),
                    React.createElement(S.Counter, null, "Challenge ended"))) })));
};
